'use strict';

var _App = require('./App');

var _reactHotLoader = require('react-hot-loader');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Enable React devtools
window.React = _react2.default;

$(document).ready(function () {
	var rootElement = document.getElementById('logreader-root');
	_reactDom2.default.render(_react2.default.createElement(
		_reactHotLoader.AppContainer,
		null,
		_react2.default.createElement(_App.App, { inlineSettings: rootElement.dataset.inlineSettings === 'true' })
	), rootElement);

	if (module.hot) {
		module.hot.accept('./App', function () {
			var _require = require('./App'),
			    NextApp = _require.App;

			_reactDom2.default.render(_react2.default.createElement(
				_reactHotLoader.AppContainer,
				null,
				_react2.default.createElement(NextApp, {
					inlineSettings: rootElement.dataset.inlineSettings === 'true' })
			), rootElement);
		});
	}
});


//////////////////
// WEBPACK FOOTER
// ./js/index.js
// module id = 610
// module chunks = 0